import Vue from 'vue';
import axios from 'axios';
import { LoginConfig, ErrorConfig } from '@/common/utils/login-config';
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger.js';
import router from '@/common/utils/router';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';

const Request = axios.create({
  baseURL: '',
  transformRequest: [(data) => {
    if (self.$sn.validate.string(data)) return data;
    if (data instanceof FormData) return data;
    return JSON.stringify(data);
  }]
});

Request.interceptors.request.use(
  config => {
    let verify = false;
    unEncryptedConfig.forEach(el => {
      if (config.url.indexOf(el) !== -1) verify = true;
    });
    if (verify || ['PUT', 'put'].includes(config.method)) config.url = config.url.replace('/encrypt', '');
    if (config.url.indexOf('/encrypt') !== -1) {
      if (['POST', 'post'].includes(config.method)) {
        if (config.data) {
          config.data = self.$sn.utils.variableEncryption(config.data);
        }
      }
    }
    return {
      ...config,
      url: config.url,
      method: config.method || 'GET',
      headers: config.header ? getTokenHeader({
        url: config.url,
        method: config.method || 'GET',
        data: config.data || ''
      }) : getHeader({
        url: config.url,
        method: config.method || 'GET',
        data: config.data || ''
      }),
      data: config.data || '',
      emulateJSON: config.emulateJSON || true
    };
  }
);

Request.defaults.retry = 2;
Request.defaults.retryDelay = 1 * 1000;
Request.interceptors.response.use(
  result => {
    if (result) {
      if (result.config && result.config.url && result.config.url.indexOf('encrypt') !== -1) {
        if (result.data && result.data.data) {
          result.data.data = JSON.parse(self.$sn.utils.variableDecryption(result.data.data));
        }
      }
    }
    return result;
  },
  error => {
    const config = error.config;
    if (error.response) {
      console.error('error.response.status:' + error.response.status);
      if (error.response.status === 403) {
        Tools.removeEntireInformation();
        // 网络异常-您的访问过于频繁,请稍后再试。
        self.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
          title: Messages.C008,
          caption: Messages.C028
        });
        if (router.currentRoute.path === ErrorConfig) window.eventBus.$emit('Broadcast_NavigatorFunction');
        else router.replace(ErrorConfig);
        return Promise.reject(error);
      }
    }
    if (error.request) {
      console.error('error.request.status:' + error.request.status);
      if (error.request.status === 0 || error.request.status === 401) {
        // 返回登录页面
        Tools.removeLoginInformation();
        const current = router.currentRoute.path;
        if ([LoginConfig, ErrorConfig].includes(current)) {
          // 网络异常-您的访问过于频繁,请稍后再试。
          self.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
            title: Messages.C008,
            caption: Messages.C028
          });
          if (current === ErrorConfig) window.eventBus.$emit('Broadcast_NavigatorFunction');
          else router.replace(ErrorConfig);
        }
        else router.replace(LoginConfig);
        return Promise.reject(error);
      }
    }
    if (!config || !config.retry) {
      return Promise.reject(error);
    }
    config.value = config.value || 1;
    if (config.value >= config.retry) {
      return Promise.reject(error);
    }
    config.value += 1;
    const repeat = new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1 * 1000);
    });
    return repeat.then(() => {
      return Request(config);
    });
  }
);

const Problem = function(error, standard) {
  console.log('连接失败', error);
  const result = {};
  result.code = 400;
  result.msg = Messages.C001;
  return standard || result;
};

const unEncryptedConfig = [
  Swagger.pcEntireScheduleInfoByCondition,
  Swagger.uploadBizFile,
  Swagger.qrLogin
];

const getHeader = function(params) {
  const type = 'application/json';
  // if (['POST', 'post'].includes(params.method) && params.data && self.$sn.validate.string(params.data) && !self.$sn.validate.json(params.data)) {
  //   type = 'text/plain';
  // }
  return {
    'Content-Type': type,
    'Accept': 'application/json'
  };
};

const getTokenHeader = function(params) {
  const type = 'application/json';
  // if (['POST', 'post'].includes(params.method) && params.data && self.$sn.validate.string(params.data) && !self.$sn.validate.json(params.data)) {
  //   type = 'text/plain';
  // }
  const header = {
    'Content-Type': type,
    'Accept': 'application/json'
  };
  if (getToken()) Vue.set(header, 'Authorization', getToken());
  return header;
};

const getToken = function() {
  let token = '';
  if (self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()).access_token) {
    token = 'Bearer ' + self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()).access_token;
  }
  return token;
};

const getRefreshToken = function() {
  let token = '';
  if (self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()) && self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()).refresh_token) {
    token = self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId()).refresh_token;
  }
  return token;
};

export {
  Request,
  Problem,
  unEncryptedConfig,
  getHeader,
  getTokenHeader,
  getToken,
  getRefreshToken
};
